var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-insights" },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 5, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Engagement:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          Math.round(
                            _vm.totalTimeMinutes / 60 +
                              _vm.totalHomeTaskTime / 60 +
                              _vm.totalDealDropTime / 60
                          )
                        ) + " Hr"
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Product interactions:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          Math.round(
                            _vm.productTotalTimeMinutes / 60 +
                              _vm.homeTaskMediaTime / 60 +
                              _vm.totalSelfies / 60
                          )
                        ) + " Hr"
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Survey:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.surveyTotalTimeMinutes / 60
                            ? Math.ceil(_vm.surveyTotalTimeMinutes / 60)
                            : 0
                        ) + " Hr"
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Media:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          Math.round(
                            _vm.homeTaskMediaTime / 60 + _vm.totalSelfies / 60
                          )
                        ) + " Hr"
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Deal Drop:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(Math.round(_vm.totalDealDropTime / 60)) + " Hr"
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }